import { createNode } from '@glueapp/graph-types';

export const SquareRoot = createNode({
    id: 'Square Root',
    name: 'Square Root',
    description: 'Gives the positive square root of the value',
    aiDescription:
        'Computes the square root of a number. Connect a value to the "Value" input port; the "Result" output port provides the square root.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Value: {
            kind: 'number',
        },
    },
    outPorts: {
        Result: {
            kind: 'number',
        },
    },
    execute: function (input) {
        return { output: { Result: Math.sqrt(input.inPorts.Value) } };
    },
});
